import React from 'react';

const TicketFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="ticket-fill_svg__a"
                d="M11 0s0 3.5-3 3.5S5 0 5 0H0v20h5s0-3 3-3 3 3 3 3h5V0h-5zm2 10.5h-2v-1h2v1zm-4 0H7v-1h2v1zm-4 0H3v-1h2v1z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(4 2)">
            <mask id="ticket-fill_svg__b" fill="#fff">
                <use xlinkHref="#ticket-fill_svg__a" />
            </mask>
            <use fill="#45494E" xlinkHref="#ticket-fill_svg__a" />
            <g mask="url(#ticket-fill_svg__b)">
                <path fill="#000" d="M-4-2h24v24H-4z" />
            </g>
        </g>
    </svg>
);

TicketFillSvg.displayName = 'TicketFillSvg';
export default TicketFillSvg;
